import { createBrowserRouter, type RouteObject } from "react-router";

// Layouts
import { AppShell } from "@/components/layout/AppShell";

// Public pages
import { Landing } from "@/pages/Landing";
import { Register } from "@/pages/Register";
import { AdminPasscodeEntry } from "@/pages/AdminPasscodeEntry";
import { ClientPasscodeSetup } from "@/pages/ClientPasscodeSetup";
import { ClientPasscodeEntry } from "@/pages/ClientPasscodeEntry";

// Admin pages
import { AdminDashboard } from "@/pages/admin/Dashboard";
import { ClientList } from "@/pages/admin/ClientList";
import { ClientCreate } from "@/pages/admin/ClientCreate";
import { ClientManage } from "@/pages/admin/ClientManage";
import { AdminChores } from "@/pages/admin/Chores";
import { AdminRules } from "@/pages/admin/Rules";
import { AdminRewards } from "@/pages/admin/Rewards";
import { AdminPunishments } from "@/pages/admin/Punishments";
import { AdminSessions } from "@/pages/admin/Sessions";
import { AdminSessionDetail } from "@/pages/admin/SessionDetail";
import { AdminSessionEdit } from "@/pages/admin/SessionEdit";
import { AdminMessages } from "@/pages/admin/Messages";
import { AdminProfile } from "@/pages/admin/Profile";
import { ClientEdit } from "@/pages/admin/ClientEdit";

// Shared pages
import { AdminActivityHistory, ClientActivityHistory } from "@/pages/shared/ActivityHistory";

// Client pages
import { ClientDashboard } from "@/pages/client/Dashboard";
import { ClientChores } from "@/pages/client/Chores";
import { ClientRules } from "@/pages/client/Rules";
import { ClientSessions } from "@/pages/client/Sessions";
import { ClientSessionDetail } from "@/pages/client/SessionDetail";
import { ClientMessages } from "@/pages/client/Messages";
import { ClientProfile } from "@/pages/client/Profile";

const routes: RouteObject[] = [
  // Public routes (no shell)
  {
    path: "/",
    element: <Landing />,
  },
  {
    path: "/register",
    element: <Register />,
  },

  // Admin passcode entry (no shell)
  {
    path: "/admin/:jwt",
    element: <AdminPasscodeEntry />,
  },

  // Admin routes (with shell)
  {
    path: "/admin/:jwt",
    element: <AppShell role="admin" />,
    children: [
      { path: "dashboard", element: <AdminDashboard /> },
      { path: "profile", element: <AdminProfile /> },
      { path: "clients", element: <ClientList /> },
      { path: "clients/new", element: <ClientCreate /> },
      { path: ":clientId", element: <ClientManage /> },
      { path: ":clientId/edit", element: <ClientEdit /> },
      { path: ":clientId/chores", element: <AdminChores /> },
      { path: ":clientId/rules", element: <AdminRules /> },
      { path: ":clientId/rewards", element: <AdminRewards /> },
      { path: ":clientId/punishments", element: <AdminPunishments /> },
      { path: ":clientId/sessions", element: <AdminSessions /> },
      { path: ":clientId/sessions/:sessionId", element: <AdminSessionDetail /> },
      { path: ":clientId/sessions/:sessionId/edit", element: <AdminSessionEdit /> },
      { path: ":clientId/messages", element: <AdminMessages /> },
      { path: ":clientId/activity", element: <AdminActivityHistory /> },
    ],
  },

  // Client passcode
  {
    path: "/client/:jwt",
    element: <ClientPasscodeEntry />,
  },

  // Client routes (with shell)
  {
    path: "/client/:jwt",
    element: <AppShell role="client" />,
    children: [
      { path: "dashboard", element: <ClientDashboard /> },
      { path: "chores", element: <ClientChores /> },
      { path: "rules", element: <ClientRules /> },
      { path: "sessions", element: <ClientSessions /> },
      { path: "sessions/:sessionId", element: <ClientSessionDetail /> },
      { path: "messages", element: <ClientMessages /> },
      { path: "activity", element: <ClientActivityHistory /> },
      { path: "profile", element: <ClientProfile /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
